import React from 'react';
import { MarketOpportunity } from '../components/MarketOpportunity';
import { BusinessModel } from '../components/BusinessModel';
import { GrowthRoadmap } from '../components/GrowthRoadmap';
import { FundraiseSection } from '../components/FundraiseSection';
import { LeadershipSection } from '../components/LeadershipSection';
import { TractionSection } from '../components/TractionSection';
import { VisionSection } from '../components/VisionSection';
export function InvestorsPage() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-409" data-mp="1al0yipxp410v">
      {/* Navigation */}
      <nav className="sticky top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto bg-ivory/95 backdrop-blur-sm border-b border-charcoal/5" data-id="element-410" data-mp="16kgzthxh4pcm">
        <a href="/" data-id="element-411" data-mp="wkq5bg8wyacj">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-8 md:h-10" data-id="element-412" data-mp="wl9qd5tv1eus" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-413" data-mp="2a5l32zlaca9a">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-414" data-mp="2eynzdfhg5xt6">
            Home
          </a>
          <a href="#platform" className="hover:text-purple-700 transition-colors" data-id="element-415" data-mp="20ab2mgajcaxm">
            Platform
          </a>
          <a href="#practitioners" className="hover:text-purple-700 transition-colors" data-id="element-416" data-mp="2sxx2pekk0xfq">
            Practitioners
          </a>
          <a href="/investors" className="text-purple-700 font-semibold" data-id="element-417" data-mp="2xvyv4q3ve93v">
            Investors
          </a>
        </div>
      </nav>

      {/* Hero Section for Investors */}
      <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-ivory pt-20 pb-20" data-id="element-418" data-mp="2nx9boswbsgli">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-200/30 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-breathe" data-id="element-419" data-mp="17izpa4bn91xb"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[30rem] h-[30rem] bg-purple-200/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-breathe" style={{
        animationDelay: '2s'
      }} data-id="element-420" data-mp="3f6c9qrc92eak"></div>

        <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-421" data-mp="35dwrru0ydppo">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full border border-purple-200/60 bg-white/30 backdrop-blur-sm mb-8" data-id="element-422" data-mp="30gwkxgwa4ixi">
            <span className="text-sm font-medium tracking-wide uppercase text-charcoal/80" data-id="element-423" data-mp="2rfyrttndpvtp">
              Investment Opportunity
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-charcoal leading-[1.1] mb-8 tracking-tight" data-id="element-424" data-mp="2mjhty7qdo33f">
            Building the Future of{' '}
            <span className="italic text-charcoal/80" data-id="element-425" data-mp="koz6kmaadrkm">Women's Wellness</span>
          </h1>

          <p className="text-lg md:text-xl text-charcoal/70 max-w-3xl mx-auto mb-12 font-light leading-relaxed" data-id="element-426" data-mp="frz2ui0wt0wo">
            Join us in creating a new category of care — where technology,
            community, and trusted practitioners converge to serve the most
            underserved market in healthcare.
          </p>
        </div>
      </section>

      {/* Investor-focused sections */}
      <MarketOpportunity data-id="element-427" data-mp="11zmeajz0ck18" />
      <BusinessModel data-id="element-428" data-mp="11ytgw9lxv6vr" />
      <TractionSection data-id="element-429" data-mp="121fp8bgnlqf1" />
      <GrowthRoadmap data-id="element-430" data-mp="4bugbns4lesl" />
      <VisionSection data-id="element-431" data-mp="4cduquikhl1v" />
      <LeadershipSection data-id="element-432" data-mp="4d5hdfu6s8g0" />
      <FundraiseSection data-id="element-433" data-mp="4dyssu43bm4h" />

      {/* Minimal Footer */}
      <footer className="bg-charcoal text-ivory/50 py-8 border-t border-white/10" data-id="element-434" data-mp="9bqidhh9iw5i">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm" data-id="element-435" data-mp="e9ilz8r9s6pj">
          <p data-id="element-436" data-mp="jag3dj4ggwpz">© {new Date().getFullYear()} Fem Entity. All rights reserved.</p>
          <a href="/privacy-policy" className="hover:text-ivory transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-300 rounded" data-id="element-437" data-mp="1ppqjgvrugruc">
            Privacy Policy
          </a>
        </div>
      </footer>
    </main>;
}